import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LOGGED_IN_SESSION_KEY, ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from "../../../constants";

export const LogoutCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clearing all tokens and state after returning from Keycloak
    sessionStorage.setItem(LOGGED_IN_SESSION_KEY, false);
    localStorage.setItem(ACCESS_TOKEN_KEY, "");
    localStorage.setItem(REFRESH_TOKEN_KEY, "");

    // Redirect to login page
    navigate("/login", { replace: true });
  }, [navigate]);

  return null;
};